<script setup lang="ts">
//
</script>

<template>
  <div class="flex items-center gap-2">
    <span
      class="flex overflow-hidden rounded-full w-[30px] h-[30px] items-center justify-center bg-[#1515E5] p-[1px] relative z-10 shrink-0"
    >
      <span
        class="flex overflow-hidden rounded-full w-full h-full items-center justify-center"
      >
        <ApLogoIcon class="w-full h-full" />
      </span>
    </span>
    <span
      class="text-white text-[14px] flex select-none whitespace-nowrap"
      :draggable="false"
    >
      {{ 'apostatudo.bet.br' }}
    </span>
    <NuxtIcon
      class="text-white text-[14px]"
      :filled="false"
      name="perfil-oficial/embaixador-oficial"
    />
  </div>
</template>
